/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface EditSilencedUntilRequest
 */
export interface EditSilencedUntilRequest {
  /**
   *
   * @type {string}
   * @memberof EditSilencedUntilRequest
   */
  alarmId: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof EditSilencedUntilRequest
   */
  silencedUntil: OffsetDateTime;
}

/**
 * Check if a given object implements the EditSilencedUntilRequest interface.
 */
export function instanceOfEditSilencedUntilRequest(
  value: object,
): value is EditSilencedUntilRequest {
  if (!("alarmId" in value) || value["alarmId"] === undefined) return false;
  if (!("silencedUntil" in value) || value["silencedUntil"] === undefined)
    return false;
  return true;
}

export function EditSilencedUntilRequestFromJSON(
  json: any,
): EditSilencedUntilRequest {
  return EditSilencedUntilRequestFromJSONTyped(json, false);
}

export function EditSilencedUntilRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EditSilencedUntilRequest {
  if (json == null) {
    return json;
  }
  return {
    alarmId: json["alarmId"],
    silencedUntil: json["silencedUntil"],
  };
}

export function EditSilencedUntilRequestToJSON(
  json: any,
): EditSilencedUntilRequest {
  return EditSilencedUntilRequestToJSONTyped(json, false);
}

export function EditSilencedUntilRequestToJSONTyped(
  value?: EditSilencedUntilRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    alarmId: value["alarmId"],
    silencedUntil: value["silencedUntil"],
  };
}
